import { useQuery } from 'react-query';
import { getHousePrices, calculateAnnualGrowth } from '../services/housePricesService';
import useSearchState from "./useSearch";
import {queryClient} from "../services/queryClient";

export const getCacheKeyForHousePrices = (postcode) => `house_prices_data_${encodeURIComponent(postcode)}`;

const useHousePrices = (postcode) => {
  const cacheKey = getCacheKeyForHousePrices(postcode);
  const {searchState} = useSearchState()
  const savedSearchId = searchState?.savedSearchId
  const currentCacheKey= ['housePrices', cacheKey, savedSearchId];
  const enabled = Boolean(postcode) && (savedSearchId === null);

  return useQuery(
    // ['housePrices', postcode],
    currentCacheKey,
    async () => {
      const housePricesData = await getHousePrices(postcode);
      let sales = [];
      let regionPriceIndex = null;

      if (housePricesData && typeof housePricesData === 'object') {
        if (Array.isArray(housePricesData.sales)) {
          sales = housePricesData.sales;
        } else if (Array.isArray(housePricesData)) {
          sales = housePricesData;
        }
        if (housePricesData.regionPriceIndex) {
          regionPriceIndex = housePricesData.regionPriceIndex;
        }
      }

      const annualGrowth = calculateAnnualGrowth(sales);

      return {
        sales,
        data: sales,
        regionPriceIndex,
        annualGrowth,
      };
    },
    {
      enabled,
      // enabled: !!postcode,
      staleTime: Infinity,
      initialData:() => queryClient.getQueryData(currentCacheKey),
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );
};

export default useHousePrices;
